import React, { useEffect } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { Grid, StepConnector, withStyles } from "@material-ui/core";
import BasicInfo from "../../StepperComponent/BasicInfo";
import NDA from "../../StepperComponent/NDA";
import ShareLoginCredentials from "../../StepperComponent/Share_Login_Credentials";
import DueDiligenceCall from "../../StepperComponent/DueDiligence";
import Questionnaire from "../../StepperComponent/Questionnaire";
import WorkingWithAcuity from "../../StepperComponent/WorkingWithAcuity";
import ContractDocumentation from "../../StepperComponent/ContractDocumentition";
import CoachingProfileField from "../../StepperComponent/CoachingProfileField";
import CommisionInfoAdmin from "../../StepperComponent/CommisionInfoAdmin";
import AssessmentProfile from "../../StepperComponent/AssessmentProfile";
import AssociateCoaches from "../../StepperComponent/Associate_Coaches";
import FacilitationProfile from "../../StepperComponent/FacilititationProfile";
import MentoringProfile from "../../StepperComponent/MentoringProfile";
import NotFound from "../../StepperComponent/NotFound";
import HeaderMenu from "../../../../Components/HeaderMenu";
import clsx from "clsx";
import { Check } from "@material-ui/icons";
import OtherQuestions from "../../StepperComponent/OtherQuestions";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useDispatch, useSelector } from "react-redux";
import Gdpr from "../../StepperComponent/Gdpr";
import PanelAccess from "../../StepperComponent/PanelAccess";
import { useHistory } from "react-router";
import GeneralProfile from "../../StepperComponent/GeneralProfile";
import moment from "moment";
import { DELETE_STEPPER_DATA } from "../../../../Redux/actions";
import Loader from "../../../../Components/Loader";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    button: {
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    actionsContainer: {
      marginBottom: theme.spacing(2),
    },
    resetContainer: {},
    stepIcon: {
      color: "green",
    },
    commonGrid: {
      textAlign: "left",
      backgroundColor: "#F7F7F7",
      // overflow: "auto"
    },
    commonTypography: {
      color: "#4A4A4A",
      fontWeight: "bold",
    },
  })
);
const QontoConnector = withStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 20,
    alignItems: "left",
    marginLeft: 8,
  },

  active: {
    "& $line": {
      borderColor: "#784af4",
    },
    marginLeft: 9,
    height: 20,
  },
  completed: {
    "& $line": {
      borderColor: "#784af4",
    },
    marginLeft: 9,
    height: 20,
  },
  line: {
    height: 18,
  },
})(StepConnector);
const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "left",
  },
  active: {
    color: "#784af4",
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "#EF7000",
  },
  completed: {
    color: "#fff",
    backgroundColor: "#EF7000",
    zIndex: 1,
    fontSize: 14,
    borderRadius: "50%",
    padding: 3,
  },
});
function QontoStepIcon(props: any, stepperId: any) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      style={{ paddingTop: "6px" }}
      className={clsx(classes.root, { [classes.active]: active })}
    >
      {active ? (
        <div
          style={{
            borderColor: "#EF7000",
            borderWidth: 1,
            padding: 3,
            backgroundColor: "#fff",
            borderRadius: "50%",
            width: 8,
            height: 8,
            borderStyle: "solid",
          }}
        >
          <div className={classes.circle} />
        </div>
      ) : stepperId != null ? (
        <div>
          <Check className={classes.completed} />
        </div>
      ) : (
        <div
          style={{
            borderColor: "#EF7000",
            borderWidth: 1,
            padding: 3,
            backgroundColor: "#fff",
            borderRadius: "50%",
            width: 8,
            height: 8,
            borderStyle: "solid",
          }}
        ></div>
      )}
    </div>
  );
}

const trainLineKeyMapping = [
  { label: "Information and contact area", mappedKey: "partner_profile" },
  { label: "Panel access", mappedKey: "partner_panel_access_id" },
  {
    label: "Share login credentials",
    mappedKey: "partner_share_login_credential_ids",
  },
  { label: "Non disclosure agreement (NDA)", mappedKey: "partner_nda_id" },
  { label: "Working with Acuity Coaching (WWA)", mappedKey: "partner_wwa_id" },
  { label: "Due diligence", mappedKey: "due_diligence_id" },
  { label: "Additional partner information", mappedKey: "questionnaire_id" },
  { label: "Commercials and delivery", mappedKey: "extraQuestion_id" },
  { label: "General profile fields", mappedKey: "general_profile_id" },
  { label: "Coaching profile fields", mappedKey: "coaching_profile_field_id" },
  {
    label: "Facilitation profile fields",
    mappedKey: "facilitation_profile_id",
  },
  { label: "Mentoring profile fields", mappedKey: "mentoring_profile_id" },
  { label: "Assessment profile fields", mappedKey: "assessment_profile_id" },
  { label: "Documentation", mappedKey: "partner_contract_document_id" },
  { label: "Feedback", mappedKey: "quality_assurance_id" },
  { label: "Commission information", mappedKey: "Commision_admin_id" },
  { label: "Associate coaches", mappedKey: "associate_coaches_id" },
  { label: "GDPR", mappedKey: "gdprs_id" },
];

function getSteps() {
  return [
    "Information and contact area",
    "Panel access",
    "Share login credentials",
    "Non disclosure agreement (NDA)",
    "Working with Acuity Coaching (WWA)",
    "Due diligence",
    "Additional partner information",
    "Commercials and delivery",
    "General profile fields",
    "Coaching profile fields",
    "Facilitation profile fields",
    "Mentoring profile fields",
    "Assessment profile fields",
    "Documentation",
    "Commission information",
    "Associate coaches",
    "GDPR",
  ];
}

function OnboardingPartnerAdmin() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const global_data = useSelector((state: any) => state.stepperReducer);
  const [activeStep, setActiveStep] = React.useState(0);
  const [profileID, setProfileID] = React.useState(0);
  // const [facilitation, setFacilitation] = React.useState(global_data.facilitation_flag);
  // const [Mentoring, setMentoring] = React.useState(global_data.mentoring_flag);
  // const [assessor, setAssessor] = React.useState(global_data.assessor_flag);
  // const [coach, setCoach] = React.useState(global_data.coach_flag);
  const steps = getSteps();

  const getStepperIdByMappingKey = (label: any) => {
    const localArr = trainLineKeyMapping.filter(
      (option) => option.label === label
    );
    return global_data[localArr[0].mappedKey];
  };

  const updateProfileId = (value: any) => {
    setProfileID(value);
  };

  useEffect(() => {
    const type: any = history.location.state;
    if (
      global_data &&
      !global_data?.partner_profile &&
      type?.type !== "create"
    ) {
      history.push("/admin/partner/list");
    }
  }, []);

  function getStepContent(step: any) {
    switch (step) {
      case 0:
        return (
          <BasicInfo
            parentSetProfileId={updateProfileId}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );
      case 1:
        return (
          <PanelAccess
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );
      case 2:
        return (
          <ShareLoginCredentials
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );
      case 3:
        return (
          <NDA
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );
      case 4:
        return (
          <WorkingWithAcuity
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );
      case 5:
        return (
          <DueDiligenceCall
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );
      case 6:
        return global_data.questionnaire_flag ? (
          <Questionnaire
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        ) : (
          <NotFound title="Additional partner information not applicable" />
        );

      case 7:
        return (
          <OtherQuestions
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );
      case 8:
        return (
          <GeneralProfile
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={
              !global_data.coach_flag &&
              !global_data.facilitation_flag &&
              !global_data.mentoring_flag &&
              !global_data.assessor_flag
                ? step
                : global_data.coach_flag
                ? step
                : global_data.facilitation_flag
                ? step + 1
                : global_data.mentoring_flag
                ? step + 2
                : global_data.assessor_flag
                ? step + 3
                : step + 4
            }
          />
        );
      case 9:
        return global_data.coach_flag ? (
          <CoachingProfileField
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={
              !global_data.facilitation_flag &&
              !global_data.mentoring_flag &&
              !global_data.assessor_flag
                ? step + 3
                : global_data.facilitation_flag
                ? step
                : global_data.mentoring_flag
                ? step + 1
                : global_data.assessor_flag
                ? step + 2
                : step + 3
            }
          />
        ) : (
          <NotFound title="Coaching profile field not applicable" />
        );

      case 10:
        return global_data.facilitation_flag ? (
          <FacilitationProfile
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={
              !global_data.mentoring_flag && !global_data.assessor_flag
                ? step + 2
                : global_data.mentoring_flag
                ? step
                : global_data.assessor_flag
                ? step + 1
                : step + 2
            }
          />
        ) : (
          <NotFound title="Facilitation profile not applicable" />
        );
      case 11:
        return global_data.mentoring_flag ? (
          <MentoringProfile
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={!global_data.assessor_flag ? step + 1 : step}
          />
        ) : (
          <NotFound title="Mentoring profile not applicable" />
        );
      case 12:
        return global_data.assessor_flag ? (
          <AssessmentProfile
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        ) : (
          <NotFound title="Assessment profile not applicable" />
        );
      case 13:
        return (
          <ContractDocumentation
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );
      case 14:
        return (
          <CommisionInfoAdmin
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );
      case 15:
        return (
          <AssociateCoaches
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );
      case 16:
        return (
          <Gdpr
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );
      default:
        return "Not available";
    }
  }

  const handleNext = (index: any) => {
    setActiveStep(index);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const [spinner, setSpinner] = React.useState(true);
  React.useEffect(() => {
    setTimeout(() => setSpinner(false), 1000);
  }, []);
  const firstElementRef = React.useRef(null);
  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (firstElementRef.current) {
      //@ts-ignore
      firstElementRef.current.scrollIntoView();
    }
  });

  return (
    <div className={classes.root} ref={firstElementRef}>
      <HeaderMenu />
      {spinner === true ? (
        <Loader />
      ) : (
        <>
          {/* <Grid
          container
          item
          xs={12}
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-end"
          style={{ backgroundColor: '#F7F7F7' }}
          >
           <div style={{
            display: 'flex',
            flexDirection:"column",
           }}>
           <Grid container item justifyContent="flex-end"  className={classes.commonGrid}>
              <Typography variant="h2" className={classes.commonTypography}>
                Last assignment date :
              </Typography>
              <Typography>
                {moment(global_data.updated_at).format("DD-MM-YYYY")}
              </Typography>
            </Grid>
            <Grid item  className={classes.commonGrid}>
              <Typography variant="h2" className={classes.commonTypography}>
                No of assignments :
              </Typography>
              <Typography>{global_data.created_by}</Typography>
            </Grid>
            <Grid item  className={classes.commonGrid}>
              <Typography variant="h2" className={classes.commonTypography}>
                Next available date :
              </Typography>
              <Typography>
                {moment(global_data.updated_at).format("DD-MM-YYYY")}
              </Typography>
            </Grid>
            <Grid item  className={classes.commonGrid}>
              <Typography variant="h2" className={classes.commonTypography}>
                Minimum coach rate :
              </Typography>
              <Typography>{global_data.created_by}</Typography>
            </Grid>
           </div>
          </Grid> */}
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid
              item
              xs={3}
              style={{
                paddingTop: 18,
                textAlign: "left",
                backgroundColor: "#F7F7F7",
                height: "calc(100vh - 64px)",
                zIndex: 1,
              }}
            >
              <Typography
                variant="h1"
                color="primary"
                style={{ fontWeight: "bold", padding: "16px 16px 16px 55px" }}
              >
                <ArrowBackIosIcon
                  style={{ fontSize: 16, color: "#077F83", cursor: "pointer" }}
                  onClick={() => {
                    history.goBack();
                    dispatch({ type: DELETE_STEPPER_DATA });
                  }}
                />{" "}
                Partner information
              </Typography>

              {global_data.created_by !== "" && (
                <Grid
                  container
                  direction="row"
                  justify="center"
                  alignItems="flex-start"
                  style={{ marginBottom: "4px" }}
                >
                  <Grid item xs={8} className={classes.commonGrid}>
                    <Grid
                      container
                      direction="row"
                      justify="center"
                      alignItems="flex-start"
                    >
                      <Grid item xs={6} className={classes.commonGrid}>
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          Partner Name
                        </Typography>
                      </Grid>
                      <Grid item xs={1} className={classes.commonGrid}>
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={5} className={classes.commonGrid}>
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          {global_data.first_name + " " + global_data.last_name}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {global_data.created_by !== "" && (
                <Grid
                  container
                  direction="row"
                  justify="center"
                  alignItems="flex-start"
                  style={{ marginBottom: "4px" }}
                >
                  <Grid
                    item
                    xs={8}
                    style={{ textAlign: "left", backgroundColor: "#F7F7F7" }}
                  >
                    <Grid
                      container
                      direction="row"
                      justify="center"
                      alignItems="flex-start"
                    >
                      <Grid item xs={6} className={classes.commonGrid}>
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          Created by
                        </Typography>
                      </Grid>
                      <Grid item xs={1} className={classes.commonGrid}>
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={5} className={classes.commonGrid}>
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          {global_data.created_by}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {global_data.created_at !== "" && (
                <Grid
                  container
                  direction="row"
                  justify="center"
                  alignItems="flex-start"
                  style={{ marginBottom: "4px" }}
                >
                  <Grid
                    item
                    xs={8}
                    style={{ textAlign: "left", backgroundColor: "#F7F7F7" }}
                  >
                    <Grid
                      container
                      direction="row"
                      justify="center"
                      alignItems="flex-start"
                    >
                      <Grid item xs={6} className={classes.commonGrid}>
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          Date created
                        </Typography>
                      </Grid>
                      <Grid item xs={1} className={classes.commonGrid}>
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={5} className={classes.commonGrid}>
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          {moment(global_data.created_at).format("DD-MM-YYYY")}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {global_data.modified_by !== "" && (
                <Grid
                  container
                  direction="row"
                  justify="center"
                  alignItems="flex-start"
                  style={{ marginBottom: "4px" }}
                >
                  <Grid
                    item
                    xs={8}
                    style={{ textAlign: "left", backgroundColor: "#F7F7F7" }}
                  >
                    <Grid
                      container
                      direction="row"
                      justify="center"
                      alignItems="flex-start"
                    >
                      <Grid
                        item
                        xs={6}
                        style={{
                          textAlign: "left",
                          backgroundColor: "#F7F7F7",
                        }}
                      >
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          Modified by
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        style={{
                          textAlign: "left",
                          backgroundColor: "#F7F7F7",
                        }}
                      >
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          :
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={5}
                        style={{
                          textAlign: "left",
                          backgroundColor: "#F7F7F7",
                        }}
                      >
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          {global_data.modified_by}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {global_data.updated_at !== "" && (
                <Grid
                  container
                  direction="row"
                  justify="center"
                  alignItems="flex-start"
                  style={{ marginBottom: "8px" }}
                >
                  <Grid
                    item
                    xs={8}
                    style={{ textAlign: "left", backgroundColor: "#F7F7F7" }}
                  >
                    <Grid
                      container
                      direction="row"
                      justify="center"
                      alignItems="flex-start"
                    >
                      <Grid
                        item
                        xs={6}
                        style={{
                          textAlign: "left",
                          backgroundColor: "#F7F7F7",
                        }}
                      >
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          Date modified
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        style={{
                          textAlign: "left",
                          backgroundColor: "#F7F7F7",
                        }}
                      >
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          :
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={5}
                        style={{
                          textAlign: "left",
                          backgroundColor: "#F7F7F7",
                        }}
                      >
                        <Typography
                          variant="h2"
                          className={classes.commonTypography}
                        >
                          {moment(global_data.updated_at).format("DD-MM-YYYY")}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              <Stepper
                activeStep={activeStep}
                orientation="vertical"
                connector={<QontoConnector />}
                style={{ backgroundColor: "#F7F7F7", paddingLeft: 55 }}
              >
                {steps.map((label, index) => (
                  <Step
                    key={label}
                    style={{ border: "none", margin: "0px", padding: "0px" }}
                  >
                    <StepLabel
                      StepIconProps={{
                        classes: { root: classes.stepIcon },
                      }}
                      style={{
                        cursor: "pointer",
                        backgroundColor: "rgb(247, 247, 247)",
                      }}
                      className={label}
                      StepIconComponent={(e) =>
                        QontoStepIcon(e, getStepperIdByMappingKey(label))
                      }
                      onClick={() => {
                        handleNext(index);
                        window.scroll({ top: 0 });
                      }}
                    >
                      <Typography
                        variant="h2"
                        style={{ color: "rgb(7, 127,131)" }}
                      >
                        {label}
                      </Typography>
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Grid>
            <Grid item xs={9} style={{ height: "calc(100vh - 64px)" }}>
              <Grid
                container
                item
                xs={12}
                // direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                style={{
                  backgroundColor: "#F7F7F7",
                  maxWidth: "35%",
                  marginRight: 0,
                  marginLeft: "auto",
                  padding: "8px",
                }}
              >
                <Grid xs={5}>Last assignment date</Grid>
                <Grid xs={2}> : </Grid>
                <Grid xs={5}>
                  {global_data.last_assignment_date
                    ? moment(
                        global_data.last_assignment_date,
                        "DD/MM/YYYY"
                      ).format("DD-MM-YYYY")
                    : "-"}
                </Grid>
                <Grid xs={5}>No of assignments</Grid>
                <Grid xs={2}> : </Grid>
                <Grid xs={5}>{global_data.no_of_assignment}</Grid>
                <Grid xs={5}>Next available date</Grid>
                <Grid xs={2}> : </Grid>
                <Grid xs={5}>
                  {global_data?.currently_available_for_assignment === "true"
                    ? "Available Now"
                    : global_data.next_available_date
                    ? moment(global_data.next_available_date).format(
                        "DD-MM-YYYY"
                      )
                    : "-"}
                </Grid>
                <Grid xs={5}>Minimum coach rate</Grid>
                <Grid xs={2}> : </Grid>
                <Grid xs={5}>
                  {global_data?.coaching_hr_id?.length > 0
                    ? global_data?.coaching_hr_id.map((rate: any) => (
                        <Grid xs={5}>{rate}</Grid>
                      ))
                    : "-"}
                </Grid>
              </Grid>
              {getStepContent(activeStep)}
              {activeStep === steps.length && (
                <Paper square elevation={0} className={classes.resetContainer}>
                  <Typography>
                    All steps completed - you&apos;re finished
                  </Typography>
                  <Button
                    disableElevation
                    onClick={handleReset}
                    className={classes.button}
                  >
                    Reset
                  </Button>
                </Paper>
              )}
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
}

export default OnboardingPartnerAdmin;
